import { criarFiltroInicial } from "../models/cartelasFornecedorModel"
import type { CartelasFornecedorState } from "../models/cartelasFornecedorModel"
import {
    CartelasFornecedorActionsTypes,
    CartelasFornecedorAction,
} from "./cartelasFornecedorActions"

export function cartelasFornecedorReducer(
    state: CartelasFornecedorState,
    action: CartelasFornecedorAction
): CartelasFornecedorState {
    switch (action.type) {
        case CartelasFornecedorActionsTypes.CARREGAR_RESULTADO:
            return {
                ...state,
                cartelas: action.payload.cartelas,
                total: action.payload.total,
                permiteResgateIncompleta: action.payload.permiteResgateIncompleta,
                isAdmin: action.payload.isAdmin,
            }
        case CartelasFornecedorActionsTypes.ATUALIZAR_FILTRO_CAMPO:
            return {
                ...state,
                filtro: { ...state.filtro, [action.payload.campo]: action.payload.valor },
            }
        case CartelasFornecedorActionsTypes.MUDAR_PAGINA:
            return { ...state, pagina: action.payload.pagina }
        case CartelasFornecedorActionsTypes.LIMPAR_FILTRO:
            return { ...state, filtro: criarFiltroInicial(), pagina: 0 }
        default:
            return state
    }
}
